// extracted by mini-css-extract-plugin
export default {"zoomModal":"v1-z"};